import type { Translations } from "../types";

const el: Translations = {
  "meta.title": "Χάρτης Κλικ ανά Χώρα",
  "meta.description":
    "Διαδραστικός παγκόσμιος χάρτης: δωρεάν κλικ ανά χώρα καθώς και επί πληρωμή υποστήριξη μέσω Stripe, PayPal και Buy Me a Coffee.",

  "app.title": "Χάρτης Κλικ ανά Χώρα",

  "map.intro":
    "Κάνε κλικ σε μια χώρα στον χάρτη για να της δώσεις μια δωρεάν ψήφο, ή στείλε της οικονομική υποστήριξη - και τα δύο προσμετρώνται στη συνδυασμένη κατάταξη παρακάτω. Ο χάρτης αντικατοπτρίζει μόνο την υποστήριξη εντός αυτής της εφαρμογής, όχι τον πραγματικό εθνικό πλούτο ή το ΑΕΠ.",
  "map.verifying": "Επαλήθευση …",
  "map.confirmNotRobot": "Πριν προσθέσεις δωρεάν κλικ, επιβεβαίωσε γρήγορα ότι δεν είσαι ρομπότ:",
  "map.tryAgain": "Δοκίμασε ξανά",
  "map.registeringClick": "Καταχώριση κλικ …",
  "map.selectedCountry": "Επιλεγμένη χώρα: {name}.",
  "map.selectFirstFeedback": "Η χώρα επιλέχθηκε. Για να προσθέσεις δωρεάν κλικ, επιβεβαίωσε πρώτα παρακάτω ότι δεν είσαι ρομπότ.",
  "map.verificationExpired": "Η επαλήθευση έληξε - επιβεβαίωσε ξανά ότι δεν είσαι ρομπότ.",
  "map.slowDown": "Λίγο πιο αργά - περίμενε μια στιγμή πριν το επόμενο κλικ σου.",
  "map.clickFailed": "Δεν ήταν δυνατή η καταχώριση του κλικ. Δοκίμασε ξανά.",
  "map.clickErrorGeneric": "Σφάλμα κατά την καταχώριση του κλικ.",
  "map.leaderboardHeading": "Κατάταξη Χωρών",
  "map.emptySelection": "Επίλεξε μια χώρα στον χάρτη για να κάνεις κλικ ή να την υποστηρίξεις.",
  "map.loadingData": "Φόρτωση δεδομένων …",

  "worldmap.loadError": "Δεν ήταν δυνατή η φόρτωση του χάρτη.",
  "worldmap.resetZoom": "Επαναφορά ζουμ",
  "worldmap.resetButton": "⤾ Επαναφορά",
  "worldmap.loadingMap": "Φόρτωση χάρτη …",
  "worldmap.unknownCountry": "Άγνωστη",
  "worldmap.ariaClicks": "{name}: {clicks} κλικ",
  "worldmap.tooltipClicks": "{clicks} κλικ",

  "legend.fewer": "Λιγότερα κλικ",
  "legend.more": "Περισσότερα κλικ",

  "list.empty": "Δεν υπάρχουν ακόμη κλικ. Γίνε ο πρώτος!",
  "list.ariaLabel": "Κατάταξη χωρών βάσει κλικ",

  "human.siteKeyMissing": "Το VITE_TURNSTILE_SITE_KEY δεν έχει οριστεί - δες το README για τη ρύθμιση.",
  "human.verificationFailedGeneric": "Η επαλήθευση απέτυχε.",
  "human.networkError":
    "Δεν ήταν δυνατή η πρόσβαση στην επαλήθευση (σφάλμα δικτύου) - έλεγξε το VITE_SUPABASE_URL, ότι το verify-human έχει αναπτυχθεί, και το ALLOWED_ORIGIN· δες README/NAVODILA.",
  "human.verificationFailedRetry": "Η επαλήθευση απέτυχε, δοκίμασε ξανά.",

  "provider.stripe": "💳 Κάρτα (Stripe)",
  "provider.paypal": "🅿️ PayPal",
  "provider.buymeacoffee": "☕ Buy Me a Coffee",

  "panel.selectedCountryLabel": "Επιλεγμένη χώρα",
  "panel.currentlyRanked": "Τρέχουσα θέση #{rank}",
  "panel.shareCopied": "Αντιγράφηκε ✓",
  "panel.shareShared": "Κοινοποιήθηκε ✓",
  "panel.shareButton": "🔗 Κοινοποίηση",

  "panel.tableClicks": "Κλικ",
  "panel.tableFree": "Δωρεάν",
  "panel.tablePaid": "Επί πληρωμή",
  "panel.rowAllTime": "Συνολικά",
  "panel.rowThisYear": "Φέτος",
  "panel.rowThisWeek": "Αυτή την εβδομάδα",
  "panel.rowToday": "Σήμερα",

  "panel.totalCombined": "Συνολικό άθροισμα:",
  "panel.totalSupport": "Συνολική υποστήριξη:",

  "panel.paymentMethod": "Τρόπος πληρωμής",
  "panel.noPaymentMethod": "Δεν υπάρχει διαθέσιμος τρόπος πληρωμής αυτή τη στιγμή.",
  "panel.supportAmount": "Ποσό υποστήριξης (EUR)",
  "panel.amountRange": "Το ποσό πρέπει να είναι μεταξύ {min} και {max}.",
  "panel.quickAmount": "{eur} €",
  "panel.estimatedClicks": "Εκτιμώμενα επί πληρωμή κλικ:",
  "panel.ratioInfo":
    "Αναλογία: {a} = {b} κλικ (π.χ. {c} = {d} κλικ). Αυτό είναι απλώς μια εκτίμηση πριν την πληρωμή - ο τελικός αριθμός κλικ υπολογίζεται και επιβεβαιώνεται πάντα από τον διακομιστή με βάση την πληρωμή που όντως επιβεβαιώθηκε.",
  "panel.preparing": "Προετοιμασία …",
  "panel.continueWith": "Συνέχεια με {provider}",
  "panel.choosePaymentMethod": "Επίλεξε τρόπο πληρωμής",
  "panel.bmcUsernameMissing": "Το VITE_BMC_USERNAME δεν έχει οριστεί - δες το README για τη ρύθμιση.",
  "panel.paypalClientIdMissing": "Το VITE_PAYPAL_CLIENT_ID δεν έχει οριστεί - δες το README για τη ρύθμιση.",

  "panel.paypalAmountInfo": "Ποσό: {amount} (εκτιμώμενα {clicks} κλικ). Ολοκλήρωσε την πληρωμή με το κουμπί PayPal παρακάτω.",
  "panel.back": "← Πίσω",

  "panel.bmcWarningTitle": "⚠️ Πριν συνεχίσεις στο BuyMeCoffee:",
  "panel.bmcWarningBody":
    "Επικόλλησε τον παρακάτω κωδικό στο πεδίο μηνύματος/σημείωσης κατά την ολοκλήρωση αγοράς — έτσι μόνο θα ξέρουμε ποια χώρα υποστηρίζεις. Χωρίς τον κωδικό, δεν μπορούμε να αποδώσουμε την πληρωμή σε καμία χώρα.",
  "panel.copy": "Αντιγραφή",
  "panel.copied": "Αντιγράφηκε ✓",
  "panel.suggestedAmount": "Προτεινόμενο ποσό:",
  "panel.bmcAmountNote":
    "(εκτιμώμενα {clicks} κλικ). Δυστυχώς το BuyMeCoffee δεν υποστηρίζει τη μεταφορά του ποσού μέσω συνδέσμου — εισήγαγέ το/επίλεξέ το μόνος σου στη σελίδα τους. Ο πραγματικός αριθμός κλικ υπολογίζεται πάντα από το ποσό που στέλνεις πραγματικά στο BuyMeCoffee, όχι από αυτή την εκτίμηση.",
  "panel.openBmc": "Άνοιγμα BuyMeCoffee και συνέχεια →",
  "panel.waitingProvider": "Αναμονή επιβεβαίωσης πληρωμής από τον πάροχο πληρωμών …",
  "panel.waitingConfirmation": "Αναμονή επιβεβαίωσης πληρωμής …",
  "panel.timedOut":
    "Ο έλεγχος έληξε λόγω χρονικού ορίου. Αν ολοκλήρωσες την πληρωμή, ο χάρτης θα ενημερωθεί μόλις ο διακομιστής λάβει την επιβεβαίωση - αυτό μπορεί μερικές φορές να διαρκέσει λίγο περισσότερο.",
  "panel.checkAgain": "Έλεγξε ξανά",

  "panel.cancelled": "Η πληρωμή ακυρώθηκε ή δεν ολοκληρώθηκε. Ο χάρτης δεν έχει αλλάξει.",
  "panel.tryAgain": "Δοκίμασε ξανά",

  "panel.confirmed": "✅ Η υποστήριξη επιβεβαιώθηκε!",
  "panel.confirmedBody": "Η {country} έλαβε {clicks} επί πληρωμή κλικ για {amount}.",

  "panel.errorPreparingSupport": "Σφάλμα κατά την προετοιμασία της υποστήριξής σου.",
  "panel.errorPreparingPayment": "Σφάλμα κατά την προετοιμασία της πληρωμής.",
  "panel.errorConfirmingPayment": "Σφάλμα κατά την επιβεβαίωση της πληρωμής.",
  "panel.errorPayingPaypal": "Σφάλμα κατά την πληρωμή με PayPal.",

  "share.unranked": "{flag}{country} χρειάζεται την υποστήριξή σου στον παγκόσμιο χάρτη!\nΒοήθησέ τη να ανέβει στην κατάταξη 👇",
  "share.rank1": "{flag}{country} είναι αυτή τη στιγμή #1!\nΒοήθησέ μας να μείνουμε στην κορυφή 👇",
  "share.rankN": "{flag}{country} είναι αυτή τη στιγμή #{rank}!\nΒοήθησέ μας να φτάσουμε στο #1 👇",

  "language.switcherLabel": "Γλώσσα",
};

export default el;
